import { useState, type ReactNode } from "react";
import { useNavigate } from "react-router-dom";
import {
  Button,
  ColorPicker,
  Dialog,
  EmojiPicker,
  TextField,
  TEMPLATE_EMOJIS,
  vars,
  type TripColor,
} from "@pack-it-up/ui-web";
import { useSession } from "../../app/SessionProvider.js";

export const NewTemplateModal = ({ open, onClose }: { open: boolean; onClose: () => void }): ReactNode => {
  const { home } = useSession();
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [emoji, setEmoji] = useState(TEMPLATE_EMOJIS[0]!);
  const [color, setColor] = useState<TripColor | undefined>(undefined);
  const [submitting, setSubmitting] = useState(false);

  const handleClose = (): void => {
    setName("");
    setEmoji(TEMPLATE_EMOJIS[0]!);
    setColor(undefined);
    onClose();
  };

  const handleCreate = async (): Promise<void> => {
    if (name.trim() === "") return;
    setSubmitting(true);
    const r = await home.getState().createTemplate({
      name: name.trim(),
      emoji,
      ...(color !== undefined ? { color } : {}),
    });
    setSubmitting(false);
    if (r.ok) {
      onClose();
      navigate(`/template/${r.value}`);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      title="New template"
      subtitle="Start blank — add categories and items once it's created."
      footer={
        <>
          <Button variant="secondary" onClick={handleClose}>
            Cancel
          </Button>
          <Button onClick={() => void handleCreate()} disabled={name.trim() === "" || submitting}>
            {submitting ? "Creating…" : "Create template"}
          </Button>
        </>
      }
    >
      <TextField
        label="Template name"
        placeholder="e.g. Beach Holiday"
        value={name}
        onChange={setName}
        autoFocus
      />
      <div style={{ marginTop: vars.space.md }}>
        <div style={{ fontSize: vars.font.sizeSm, fontWeight: vars.font.weightMedium, color: vars.color.text, marginBottom: vars.space.sm }}>
          Icon
        </div>
        <EmojiPicker value={emoji} onChange={setEmoji} canEdit />
      </div>
      <div style={{ marginTop: vars.space.md }}>
        <div style={{ fontSize: vars.font.sizeSm, fontWeight: vars.font.weightMedium, color: vars.color.text, marginBottom: vars.space.sm }}>
          Color
        </div>
        <ColorPicker value={color} onChange={setColor} label="Template color" />
      </div>
    </Dialog>
  );
};
